import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AboutandeventformComponent } from './aboutandeventform/aboutandeventform.component';

@Component({
  selector: 'app-about-us',
  imports: [CommonModule, AboutandeventformComponent],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss'
})
export class AboutUsComponent implements OnInit {

  constructor() {

  }

  ngOnInit(): void {

  }

}
